import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useTheme, Box, ThemeProvider, Tooltip } from "@mui/material";
import { tooltipContentWrapper, indicatorWrapper, tooltipDotWrapper, tooltipIndicator, tooltipLabel, tooltipReason } from "./chemistry-info.styles.js";
import { ChemistryDot } from "./components/ChemistryDot/ChemistryDot.js";
import { chemistryOptions } from "./constants.js";
import { ChemistryRating } from "./types.js";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "color-alpha";
import "../../../themes/external-theme/external-theme.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "./components/ChemistryDot/styles.js";
const ChemistryInfo = ({ rating = ChemistryRating.NORMAL, reason, label, patientNameComponent }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const options = chemistryOptions(theme);
  const chemistry = options.find((option) => option.value === rating);
  const { color, label: chemistryOptionLabel, tooltipColor } = chemistry || {};
  if (!color)
    return /* @__PURE__ */ jsx(Fragment, { children: patientNameComponent });
  const tooltipContent = /* @__PURE__ */ jsxs(Box, { sx: tooltipContentWrapper, children: [
    /* @__PURE__ */ jsxs(Box, { sx: indicatorWrapper, children: [
      /* @__PURE__ */ jsx(Box, { sx: tooltipDotWrapper, children: /* @__PURE__ */ jsx(Box, { sx: tooltipIndicator(color) }) }),
      /* @__PURE__ */ jsx(Box, { sx: tooltipLabel, children: label || t(chemistryOptionLabel || "") })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: tooltipReason, children: reason })
  ] });
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(
    Tooltip,
    {
      placement: "bottom-start",
      title: tooltipContent,
      componentsProps: {
        tooltip: {
          sx: {
            bgcolor: tooltipColor
          }
        }
      },
      children: /* @__PURE__ */ jsxs(Box, { sx: indicatorWrapper, children: [
        /* @__PURE__ */ jsx(ChemistryDot, { rating }),
        patientNameComponent
      ] })
    }
  ) });
};
export {
  ChemistryInfo
};
